import React from 'react'
import { SearchOutlined } from '@ant-design/icons'
import { Button, Tooltip, Flex } from 'antd'
import { useHistory, useRouteMatch } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { setGoBackToVehicleTest } from '../actions/go-to-vehicle-test'
import { useDispatch } from 'react-redux'

export const GlobalSearchQueryButton = ({ vin, query = null }) => {
  const history = useHistory()
  const intl = useIntl()

  return (
    <Flex gap="small" align="center">
      <Button
        color="primary"
        size="large"
        icon={<SearchOutlined />}
        onClick={() => {
          history.push(`/global-search/vin/${vin}?search_string=${query}`)
        }}
        disabled={query === null}
      >
        {query ? `View ${query}` : `Select Component`}
      </Button>
    </Flex>
  )
}
